// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invalid{
  border: 2px solid #e61515 !important;}
  input.invalid {
    color: #e61515;
}
.valid{
  border-bottom: 4px solid #4dbd74 !important;
}
.step-valid{
  color: #4dbd74 !important;
  border-top: 3px solid #4dbd74 !important;
}

.step-invalid{
  color: #e61515 !important;
  border-top: 3px solid #e61515 !important;
}
.valid-step-numnber{
  background: #4dbd74 !important;
}
.pb-1 {
  padding-bottom: 6px !important;
}
.circle-font{
    text-align: center;
    display: inline;
    margin-right: 13px;
    color: #182F7C;
    cursor: pointer;
}
.indi {
  padding: 0px 18px 10px 18px;
  align-content: center;
  align-items: center;
  counter-reset: stepCount;
  display: flex;
  justify-content: space-around;
  margin: auto;
  width: 80%;
  position: relative;
}

.indi .list {
  background: #182F7C;
  color: white;
  content: ' ';
  display: flex;
  flex-grow: 1;
  height: .3em;
  line-height: 1em;
  margin: 0;
  position: relative;
  text-align: right;
}

.indi .list::before {
  color: white;
  background: #182F7C;
  border-radius: 50%;
  counter-increment: stepCount;
  content: counter(stepCount); 
  height: 2em;
  left: -1em;
  line-height: 2em;
  position: absolute;
  text-align: center;
  top: -.85em;
  width: 2em;
}

.indi .list.valid::before {
  background-color: #4dbd74 !important;
}
.indi .list.invalid::before {
  background-color: #e61515 !important;
}

.indi .list:last-child {
  flex-basis: 0;
  flex-grow: 0;
  flex-shrink: 1;
}

.active-step .without-padding {
  background: #009CDE !important;
  color: white !important;
}

.without-padding{
  background-color: #e9ecef;
  padding: 10px 0;
  text-align: center;
  cursor: pointer;
}
.container--flex {
  margin: 0px 22px 0px 22px;
  display: flex;
}
.flex-child {
  flex: 1;
  min-width: 50px;
  min-height: 50px;
  margin: 10px;
}
.error-message{
  color: #e61515;
}

.extra-margin-bottom{
  padding-bottom: 1rem;
}
.extra-padding{
  padding: 0 30px;
}

.modal-footer{
  display: block;
}

.modal-dialog.modal-lg {
  margin: 0 auto;
  width: 65%;
  max-width: 65%;
  height: 100%;
  max-height: 100%;
}

.error-checkbox{
  outline: 2px solid #c00;
}
.pointer{
  cursor:pointer;
  text-decoration:underline !important;
}
.hide{
  display: none;
}
.md-50{
  font-size: 50px;
}

.terms-and-cond{
  margin: 0 auto;
  float: none;
  margin-bottom: 10px;
  border: 3px solid white;
}

.centering {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-text {
  background-color: #e9ecef;
  border-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 15px;
  padding-bottom: 5px;
}

.terms-message{
  padding-left: 10px;
  padding-right: 10px;

}

#termsDocModal2 {
  z-index: 1060;
}
`, "",{"version":3,"sources":["webpack://./src/app/Menus/Onboard/onboard.component.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC,CAAC;EACrC;IACE,cAAc;AAClB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".invalid{\n  border: 2px solid #e61515 !important;}\n  input.invalid {\n    color: #e61515;\n}\n.valid{\n  border-bottom: 4px solid #4dbd74 !important;\n}\n.step-valid{\n  color: #4dbd74 !important;\n  border-top: 3px solid #4dbd74 !important;\n}\n\n.step-invalid{\n  color: #e61515 !important;\n  border-top: 3px solid #e61515 !important;\n}\n.valid-step-numnber{\n  background: #4dbd74 !important;\n}\n.pb-1 {\n  padding-bottom: 6px !important;\n}\n.circle-font{\n    text-align: center;\n    display: inline;\n    margin-right: 13px;\n    color: #182F7C;\n    cursor: pointer;\n}\n.indi {\n  padding: 0px 18px 10px 18px;\n  align-content: center;\n  align-items: center;\n  counter-reset: stepCount;\n  display: flex;\n  justify-content: space-around;\n  margin: auto;\n  width: 80%;\n  position: relative;\n}\n\n.indi .list {\n  background: #182F7C;\n  color: white;\n  content: ' ';\n  display: flex;\n  flex-grow: 1;\n  height: .3em;\n  line-height: 1em;\n  margin: 0;\n  position: relative;\n  text-align: right;\n}\n\n.indi .list::before {\n  color: white;\n  background: #182F7C;\n  border-radius: 50%;\n  counter-increment: stepCount;\n  content: counter(stepCount); \n  height: 2em;\n  left: -1em;\n  line-height: 2em;\n  position: absolute;\n  text-align: center;\n  top: -.85em;\n  width: 2em;\n}\n\n.indi .list.valid::before {\n  background-color: #4dbd74 !important;\n}\n.indi .list.invalid::before {\n  background-color: #e61515 !important;\n}\n\n.indi .list:last-child {\n  flex-basis: 0;\n  flex-grow: 0;\n  flex-shrink: 1;\n}\n\n.active-step .without-padding {\n  background: #009CDE !important;\n  color: white !important;\n}\n\n.without-padding{\n  background-color: #e9ecef;\n  padding: 10px 0;\n  text-align: center;\n  cursor: pointer;\n}\n.container--flex {\n  margin: 0px 22px 0px 22px;\n  display: flex;\n}\n.flex-child {\n  flex: 1;\n  min-width: 50px;\n  min-height: 50px;\n  margin: 10px;\n}\n.error-message{\n  color: #e61515;\n}\n\n.extra-margin-bottom{\n  padding-bottom: 1rem;\n}\n.extra-padding{\n  padding: 0 30px;\n}\n\n.modal-footer{\n  display: block;\n}\n\n.modal-dialog.modal-lg {\n  margin: 0 auto;\n  width: 65%;\n  max-width: 65%;\n  height: 100%;\n  max-height: 100%;\n}\n\n.error-checkbox{\n  outline: 2px solid #c00;\n}\n.pointer{\n  cursor:pointer;\n  text-decoration:underline !important;\n}\n.hide{\n  display: none;\n}\n.md-50{\n  font-size: 50px;\n}\n\n.terms-and-cond{\n  margin: 0 auto;\n  float: none;\n  margin-bottom: 10px;\n  border: 3px solid white;\n}\n\n.centering {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.card-text {\n  background-color: #e9ecef;\n  border-radius: 5px;\n  padding-left: 5px;\n  padding-right: 5px;\n  margin-bottom: 15px;\n  padding-bottom: 5px;\n}\n\n.terms-message{\n  padding-left: 10px;\n  padding-right: 10px;\n\n}\n\n#termsDocModal2 {\n  z-index: 1060;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
